<div id="printContainer" #printContainer style="visibility: hidden;">
  @if (report) {
    <div class="report-header">
      <div class="rh-left">
        <div class="rh-sub">
          BAER ACCOMPLISHMENT REPORT
        </div>
        <div class="rh-title">
          <h1 class="rh-title-h1">{{report.report_name}}</h1>
        </div>
      </div>
    </div>
  }
  @if (report) {
    <div class="report-main">
      <div class="report-right-area">
        <div class="report-area">
          <div class="report-section">
            @if (reportList) {
              <app-view-accomplishment-details [report]="report" [reportList]="reportList" [(nav)]="nav"
                (status)="statusChange($event)" (loaded)="subLoaded($event)"
              ></app-view-accomplishment-details>
            }
            @if (reportList) {
              <app-view-accomplishment-treatments [report]="report" [reportList]="reportList" [(nav)]="nav"
                (status)="statusChange($event)" (loaded)="subLoaded($event)"
              ></app-view-accomplishment-treatments>
            }
            @if (reportList) {
              <app-view-accomplishment-additional [report]="report" [reportList]="reportList" [(nav)]="nav"
                [currentUser]="currentUser" (status)="statusChange($event)" (loaded)="subLoaded($event)"
              ></app-view-accomplishment-additional>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>